import { render } from "./WorldwideSection.vue?vue&type=template&id=57dfda7a&scoped=true"
import script from "./WorldwideSection.vue?vue&type=script&lang=js"
export * from "./WorldwideSection.vue?vue&type=script&lang=js"

import "./WorldwideSection.vue?vue&type=style&index=0&id=57dfda7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57dfda7a"]])

export default __exports__